import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';

// ------------------------------------
// Store
// ------------------------------------
export const STORE_KEY = 'waiverWire';

const waiverWireReducer = (state = {}) => state;

export default waiverWireReducer;

// ------------------------------------
// View / Route
// ------------------------------------
export const WAIVER_WIRE_VIEW = `${STORE_KEY}/WAIVER_WIRE_VIEW`;

viewNames[WAIVER_WIRE_VIEW] = 'WaiverWire';
routes[WAIVER_WIRE_VIEW] = {
  path: '/in-season/fantasy-football-waiver-wire',
};



// WEBPACK FOOTER //
// ./src/app/views/WaiverWire/module/waiverWire.js